module.exports = __webpack_public_path__ + "img/MQ.4de172f5.svg";